var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",class:[
    _vm.$style.button,
    _vm.isNoTag && _vm.$style.buttonNoTag,
    _vm.icon && _vm.$style.buttonIcon,
    _vm.isSocial && _vm.$style.buttonSocial,
    _vm.disabled && _vm.$style.disabled ],attrs:{"to":_vm.to,"href":_vm.href,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('icon',{class:_vm.$style.icon,attrs:{"name":_vm.icon}}):_vm._e(),[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }